import { SvgIcon } from '@mui/material'
import React from 'react'

export const TikTokIcon = props => {
  return (
    <SvgIcon {...props} width='29px' height='33px' viewBox='0 0 29 33'>
      <path
        d='M28.8,13.95 L28.8,8.27 C26.14,8.27 24.11,7.56 22.8,6.18 C21.4554803,4.60504791 20.7022382,2.61054774 20.67,0.54 L20.67,0.13 L15.3,0 C15.3,0 15.3,0.23 15.3,0.54 L15.3,23.07 C14.9226942,25.1316932 13.2995701,26.739251 11.2343368,27.096672 C9.16910349,27.454093 7.10013762,26.4855092 6.05191234,24.6705266 C5.00368706,22.8555439 5.19870379,20.5794194 6.54039767,18.9692033 C7.88209155,17.3589872 10.0856681,16.7564719 12.06,17.46 L12.06,11.96 C11.4979932,11.8679127 10.9295002,11.8210956 10.36,11.82 C4.63832999,11.82 -3.55271368e-15,16.45833 -3.55271368e-15,22.18 C-3.55271368e-15,27.90167 4.63832999,32.54 10.36,32.54 C16.08167,32.54 20.72,27.90167 20.72,22.18 C20.7188873,21.7554434 20.6921722,21.3313403 20.64,20.91 L20.64,11.76 C23.0818167,13.2849434 25.9227734,14.047406 28.8,13.95 Z'
        id='Path'
      ></path>
    </SvgIcon>
  )
}
